import { authRoles } from "../../../auth/authRoles";
import EditPromosi from "./EditPromosi";
import Promosi from "./Promosi";
import TambahPromosi from "./TambahPromosi";

const promosiRoute = [
  {
    path: "/promosi/edit/:id",
    exact: true,
    component: EditPromosi,
    auth: authRoles.all,
  },
  {
    path: "/promosi/tambah",
    exact: true,
    component: TambahPromosi,
    auth: authRoles.all,
  },
  {
    path: "/promosi",
    exact: true,
    component: Promosi,
    auth: authRoles.all,
  },
];

export default promosiRoute;
